import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RecordItemProps } from '../../congratulations-full-screen.types';
import { StyledRecordItemWrapper, StyledRecordTitle, StyledStaticsContent } from './records-step.styles';
export const RecordItem = ({
  title,
  icon,
  content,
  recordType
}: RecordItemProps) => <StyledRecordItemWrapper data-type={recordType} data-sentry-element="StyledRecordItemWrapper" data-sentry-component="RecordItem" data-sentry-source-file="record-item.tsx">
    <StyledRecordTitle data-sentry-element="StyledRecordTitle" data-sentry-source-file="record-item.tsx">{title}</StyledRecordTitle>
    {icon && <FontAwesomeIcon icon={icon} />}
    <StyledStaticsContent data-sentry-element="StyledStaticsContent" data-sentry-source-file="record-item.tsx">{content}</StyledStaticsContent>
  </StyledRecordItemWrapper>;